<template>
    <div style="height: 600px;">
    <a-spin :spinning="isLoading">
    <a-tabs v-model:activeKey="activeKey">
        <a-tab-pane key="1" :tab="tabstitle.invalid_con">
            <a-table :dataSource="cneeData" :columns="cneeColumn" :pagination="cneePage" @change="tableCneeHandle" size="small">
                <template #bodyCell="{column, record}">
                    <template v-if="column.key === 'houseBillNumber'">
                        <div v-if="record.houseBillNumber === null">-</div>
                        <div v-else>{{ record.houseBillNumber }}</div>
                    </template>
                    <template v-else-if="column.key === 'cneeName'">
                        <div> {{ record.lastName }} {{ record.firstName }}</div>
                    </template>
                </template>
            </a-table>
        </a-tab-pane>
        <a-tab-pane key="2" :tab="tabstitle.invalid_addr">
            <a-table :dataSource="addressData" :columns="addressColumn" :pagination="addressPage" @change="tableAddrHandle" size="small">
                <template #bodyCell="{column, record}">
                    <template v-if="column.key === 'houseBillNumber'">
                        <div v-if="record.houseBillNumber === null">-</div>
                        <div v-else>{{ record.houseBillNumber }}</div>
                    </template>
                    <template v-else-if="column.key === 'addr'">
                        <div> {{ record.address }}, {{ record.city }},{{ record.state }}</div>
                    </template>
                </template>
            </a-table>
        </a-tab-pane>

        <a-tab-pane key="3" :tab="tabstitle.overweight">
            <a-table :dataSource="overweightData" :columns="overweightColumn" :pagination="overweightPage" @change="tableOverweightHandle" size="small">
                <template #bodyCell="{column, record}">
                    <template v-if="column.key === 'houseBillNumber'">
                        <div v-if="record.houseBillNumber === null">-</div>
                        <div v-else>{{ record.houseBillNumber }}</div>
                    </template>
                    <template v-else-if="column.key === 'shipDesc'">
                        <div>{{ record.nameEn }} <a :href="record.extraInformation.productUrl" target="_blank"><LinkOutlined /></a></div>
                    </template>
                    <template v-else-if="column.key === 'weight'">
                        <div>{{ record.weight }}{{ record.weightUom }} </div>
                    </template>
                </template>
            </a-table>
        </a-tab-pane>
    </a-tabs>
    </a-spin>
    </div>
</template>
<script lang="ts">
import { ref, defineComponent, reactive, onMounted, nextTick } from "vue"
import Api from "@/api/Api"
import { LinkOutlined } from "@ant-design/icons-vue"
export default defineComponent({
    name : "MbolWarning",
    components:{
        LinkOutlined
    },
    props : [
        'selectWarningItem'
    ],

    setup(props) {
        //console.log("test ", props.selectWarningItem)
        const selectWarningItem : any = props.selectWarningItem
        const isLoading = ref(false)
        const activeKey = ref("1")
        const tabstitle = reactive({
            invalid_con : "Invalid consignee",
            invalid_addr : "Invalid adress",
            overweight : "OverWeight",
        })

        const cneeData = ref()
        const cneeColumn = [
            {title: "Hbol", dataIndex : "houseBillNumber", key : "houseBillNumber",width : "50%"},
            {title: "Invalid Consignee", key: "cneeName", width: "50%"}
        ]
        const cneePage = reactive({
            current : 1,
            pageSize : 10,
            total : 0,
            showSizeChanger : false,
            showQuickJumper : false,
            showLessItems : false,
        })

        const addressData = ref()
        const addressColumn = [
            {title: "Hbol", dataIndex : "houseBillNumber", key : "houseBillNumber", width: "50%"},
            {title: "Invalid Address", key: "addr", width: "50%"}
        ]
        const addressPage = reactive({
            current : 1,
            pageSize : 10,
            total : 0,
            showSizeChanger : false,
            showQuickJumper : false,
            showLessItems : false,
        })

        const overweightData = ref()
        const overweightColumn = [
            {title : "Hbol", dataIndex : "houseBillNumber", key : "houseBillNumber"},
            {title : "Shipment Desc", dataIndex: "nameEn", key: "shipDesc"},
            {title: "HTS Code", dataIndex : "htsCode", key: "htsCode"},
            {title: "Weight", key : "weight"},
        ]
        const overweightPage = reactive({
            current : 1,
            pageSize : 10,
            total : 0,
            showSizeChanger : false,
            showQuickJumper : false,
            showLessItems : false,
        })

        onMounted(() =>{
            nextTick(async()=>{
                show_loading(true)
                await getInvalidCons()
                show_loading(true)
                await getInvalidAddr()
                show_loading(true)
                await getOverWeight()
                show_loading(false)
            })
        })

        const getInvalidCons = async()=>{
            let params ={
                pageSize : cneePage.pageSize,
                pageNum : cneePage.current
            }
           
            cneeData.value = []
            let response_data = await Api.getInvalidConsigneeName(selectWarningItem.masterBillNumber, params)
            show_loading(false)
            if( response_data && response_data.code === 200){
                tabstitle.invalid_con = "Invalid consignee" + " (" + response_data.total + ")"
                cneePage.total = response_data.total
                cneeData.value = response_data.rows
            }
            
        }

        const getInvalidAddr = async()=>{
            let params ={
                pageSize : addressPage.pageSize,
                pageNum : addressPage.current
            }
            
            let response_data = await Api.getInvalidAddress(selectWarningItem.masterBillNumber, params)
            addressData.value = []
            show_loading(false)
            if( response_data && response_data.code === 200){
                tabstitle.invalid_addr = "Invalid adress" + " (" + response_data.total + ")"
                addressPage.total = response_data.total
                addressData.value = response_data.rows

                //console.log(response_data)
            }
        }

        const getOverWeight = async() => {
            let params ={
                pageSize : overweightPage.pageSize,
                pageNum : overweightPage.current
            }
            let response_data = await Api.getOverWeight(selectWarningItem.masterBillNumber, params)
            show_loading(false)
            if( response_data && response_data.code === 200){
                tabstitle.overweight = "OverWeight" + " (" + response_data.total + ")"
                overweightPage.total = response_data.total
                overweightData.value = response_data.rows
                console.log(response_data)
            }
        }

        const tableCneeHandle = (pagination : any) =>{
            if( cneePage.current === pagination.current && cneePage.pageSize === pagination.pageSize){
                return
            }else{
                //cneePage.total = 0
                cneePage.current = pagination.current
                //cneePage.pageSize = pagination.pageSize
                show_loading(true)
                getInvalidCons()
            }
        }

        const tableAddrHandle = (pagination : any) =>{
            if( addressPage.current === pagination.current && addressPage.pageSize === pagination.pageSize){
                return
            }else{
                //addressPage.total = 0
                addressPage.current = pagination.current
                //cneePage.pageSize = pagination.pageSize
                show_loading(true)
                getInvalidAddr()
            }
        }

        const tableOverweightHandle = (pagination : any) =>{
            if( overweightPage.current === pagination.current && overweightPage.pageSize === pagination.pageSize){
                return
            }else{
                
                overweightPage.current = pagination.current
                show_loading(true)
                getOverWeight()
            }
        }

        const show_loading = (b: boolean) =>{
            isLoading.value = b
        }

        return {
            isLoading,
            activeKey,
            tabstitle,
            cneeData,
            cneeColumn,
            cneePage,
            addressData,
            addressColumn,
            addressPage,
            overweightData,
            overweightColumn,
            overweightPage,
            tableCneeHandle,
            tableAddrHandle,
            tableOverweightHandle,
        }
    },
})
</script>